import { render, staticRenderFns } from "./ui-auth.vue?vue&type=template&id=aacff358&scoped=true&"
import script from "./ui-auth.vue?vue&type=script&lang=js&"
export * from "./ui-auth.vue?vue&type=script&lang=js&"
import style0 from "./ui-auth.vue?vue&type=style&index=0&id=aacff358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacff358",
  null
  
)

export default component.exports